// import "./bootstrap.js";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

function initPostSlider() {
  const postsSliders = document.querySelectorAll(".posts-slider");

  if (!postsSliders.length) return;

  postsSliders.forEach(function (el) {
    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        prevEl: "#swiper-arrow-insights-left",
        nextEl: "#swiper-arrow-insights-right",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1320: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
      },
    });
  });
}

function initPortfolioGallery() {
  const portfolioGallery = document.querySelector(".portfolio-gallery-wrap");
  if (!portfolioGallery) return;
  console.log( portfolioGallery.querySelector(".swiper-pagination"));
  new Swiper(portfolioGallery.querySelector('.portfolio-gallery'), {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      prevEl: portfolioGallery.querySelector(".portfolio-swiper-button-prev"),
      nextEl: portfolioGallery.querySelector(".portfolio-swiper-button-next"),
    },
    pagination:{
      el:  portfolioGallery.querySelector(".swiper-pagination"),
      clickable: true,
    }
  });
}

function initPortfolioInfiniteScroll() {
  const wraps = document.querySelectorAll(".artify-portfolio-wrap");
  if (!wraps.length) return;
  
  wraps.forEach(function (wrap) {
    const grid = wrap.querySelector(".artify-portfolio-grid");
    const loader = wrap.querySelector(".artify-portfolio-loader");
    const perPage = parseInt(wrap.dataset.perPage, 10) || 9;
    const maxPages = parseInt(wrap.dataset.maxPages, 10) || 1;
    let page = parseInt(wrap.dataset.page, 10) || 1;
    let loading = false;
    console.log(loader);
    if (!grid || !loader || page >= maxPages) return;

    function loadMore() {
      loading = true;
      loader.classList.add("is-active");

      const nextPage = page + 1;
      const body = new URLSearchParams({
        action: "dmn_ajax_call",
        endpoint: "artify_portfolio_load_more",
        nonce: dmnobj.dmn_nonce,
        page: nextPage,
        per_page: perPage,
      });

      fetch(dmnobj.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          const data = response && response.data;

          if (response && response.success && data && data.html) {
            grid.insertAdjacentHTML("beforeend", data.html);
            page = nextPage;
            wrap.dataset.page = String(page);
          }

          loading = false;
          loader.classList.remove("is-active");

          if (!data || !data.has_more) {
            observer.disconnect();
          }
        })
        .catch(function () {
          loading = false;
          loader.classList.remove("is-active");
        });
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !loading) {
            loadMore();
          }
        });
      },
      { rootMargin: "100px" }
    );

    observer.observe(loader);
  });
}

// Init JS function
document.addEventListener("DOMContentLoaded", (event) => {
  initPostSlider();
  initPortfolioGallery();
  initPortfolioInfiniteScroll();
});

// Jquery
jQuery(document).ready(function ($) {});
